import { notification } from 'antd';
import axios from 'axios';
import { API_TOKEN } from "../utils/constants";
import { globalInterval, setGlobalInterval } from '../components/MenuTop/MenuTop';
import { logout } from '../api/user';
import { showCloudTokenModal } from '../utils/cloudTokenModal';

const URL = import.meta.env.VITE_API_URL;

axios.interceptors.response.use(
  response => response,
  async error => {
    // Manejo del error de token de conexion a Cloud
    if (error.response?.status === 401 && error.response?.data.title) {

      localStorage.setItem('disableInterval', 'true');

      showCloudTokenModal({
        title: error.response?.data.title,
        message: error.response?.data.message,
      });

      // Detiene intervalo activo para evitar errores recurrentes
      if (globalInterval) {
        clearInterval(globalInterval);
        setGlobalInterval(null);
      }

    // Manejo de sesion invalida o token caducado
    } else if(error.response?.status === 401){
      await logout();
      notification["error"]({
        message: error.response?.data.message,
      });
      window.location.href = `/login`;
    // Otros errores se pasan para su manejo individual en cada servicio
    } else {
      return Promise.reject(error);
    }
  }
);

class Service {
  constructor(api_url) {
    this.baseUrl = api_url;
  }

  get = async (url, params = null) => {
    try {
      var config = {
        method: 'get',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Content-Type': 'application/json',
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        params
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

  download = async (url, filename) => {
    try {
      var config = {
        url: this.baseUrl + url,
        method: 'GET',
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        responseType: 'blob',
      }

      const response = await axios(config);

      const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlDownload;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  }

  post = async (url, data) => {
    try {
      var config = {
        method: 'post',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Content-Type': 'application/json',
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        data: data
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

  /**
   * Envío multipart. No se fija Content-Type: lo pone el navegador junto al boundary.
   * onProgress recibe el porcentaje subido, útil en archivos grandes como el firmware.
   */
  upload = async (url, formData, onProgress = null) => {
    try {
      var config = {
        method: 'post',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        data: formData,
        onUploadProgress: onProgress
          ? (event) => onProgress(event.total ? Math.round((event.loaded * 100) / event.total) : 0)
          : undefined
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

  put = async (url, data) => {
    try {
      var config = {
        method: 'put',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Content-Type': 'application/json',
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        data: data
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

  patch = async (url, data) => {
    try {
      var config = {
        method: 'patch',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Content-Type': 'application/json',
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        },
        data: data
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

  del = async (url) => {
    try {
      var config = {
        method: 'delete',
        url: this.baseUrl + url,
        headers: {
          'Authorization': 'Basic ' + localStorage.getItem(API_TOKEN),
          'Content-Type': 'application/json',
          'Accept-Language': localStorage.getItem('langCode') || 'es'
        }
      };
      return await axios(config)
    } catch (err) {
      if (err.response?.data.message) {
        notification["error"]({
          message: err.response?.data.message,
        });
      }
    }
  }

}

export default new Service(URL);
